module.exports = __webpack_public_path__ + "static/img/kunjin-motors.80d05b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/kunjin-motors.jpg
// module id = XW/q
// module chunks = 0